export enum AssetAspect {
  Portrait = 'portrait',
  Square = 'square'
}
